import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing24, spacing8 } from 'approot/shared/styles/spacing.style';
import { PStyled } from 'approot/shared/styles/typography.style';

export const LessonSpanishSwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${rem(spacing24)};
`;

export const LessonSpanishSwitchText = styled(PStyled)`
  margin-bottom: 0;
  margin-left: ${rem(spacing8)};
`;
